// @ts-nocheck
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  // Only load Vitally if both API token and subdomain are configured
  if (!config.public.VITALLY_API_TOKEN || !config.public.VITALLY_SUBDOMAIN) {
    return
  }

  // Add script to the document
  const script = document.createElement('script')
  script.setAttribute('defer', 'true')
  document.body.appendChild(script)

  // Expose as a global on the window object
  script.onload = () => {
    !(function (n, t, i) {
      for (
        var o = (n[t] = n[t] || []),
          r = function (i) {
            o[i] =
              o[i] ||
              function () {
                for (var n = [], t = 0; t < arguments.length; t++) n[t] = arguments[t]
                return o.push([i, n])
              }
          },
          a = 0,
          u = ['init', 'user', 'account', 'organization', 'track', 'nps'];
        a < u.length;
        a++
      ) {
        r(u[a])
      }
    })(window, 'Vitally')
    window.Vitally.init(config.public.VITALLY_API_TOKEN, config.public.VITALLY_SUBDOMAIN)
  }

  // Load the script and trigger the callback above
  script.src = 'https://cdn.vitally.io/vitally.js/v1/vitally.js'
})
